"use strict";
import { ButtonSize } from "../Button/Button";
import { TextInputSize } from "../TextInput/TextInput";
export const getButtonSize = (fieldSize = "medium") => {
  switch (fieldSize) {
    case "small": {
      return ButtonSize.Small;
    }
    case "medium": {
      return ButtonSize.Medium;
    }
    case "large": {
      return ButtonSize.Large;
    }
    default: {
      return ButtonSize.Medium;
    }
  }
};
export const getTextInputSize = (fieldSize = "medium") => {
  switch (fieldSize) {
    case "small": {
      return TextInputSize.Small;
    }
    case "medium": {
      return TextInputSize.Medium;
    }
    case "large": {
      return TextInputSize.Large;
    }
  }
};
export const getSegmentedControlSize = (fieldSize = "medium") => {
  switch (fieldSize) {
    case "small": {
      return "s";
    }
    case "medium": {
      return "m";
    }
    case "large": {
      return "l";
    }
  }
};
export const getSelectSize = (fieldSize = "medium") => {
  switch (fieldSize) {
    case "small": {
      return "s";
    }
    case "medium": {
      return "m";
    }
    case "large": {
      return "l";
    }
  }
};
export const getCheckboxSize = (fieldSize = "medium") => {
  switch (fieldSize) {
    case "small": {
      return "s";
    }
    case "medium": {
      return "m";
    }
    case "large": {
      return "l";
    }
  }
};
